<template>
  <v-container>
    <v-layout row wrap v-if="fullPicker">
      <v-flex xs12 sm6 md6 lg6 xl6>
        <v-menu v-model="picker1" :close-on-content-click="false" lazy transition="scale-transition"
          offset-y full-width min-width="290px">
          <v-text-field slot="activator" v-model="dateFrom" :label="$t('Start Date')" prepend-icon="event"
            readonly>
          </v-text-field>
          <v-date-picker color="accent" v-model="dateFrom" :min="minDate" :max="maxToday" @input="dateChangeHandler();
            picker1 = false">
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm6 md6 lg6 xl6>
        <v-menu v-model="picker2" :close-on-content-click="false" lazy transition="scale-transition"
          offset-y full-width min-width="290px">
          <v-text-field slot="activator" v-model="dateTo" :label="$t('End Date')" prepend-icon="event"
            readonly></v-text-field>
          <v-date-picker color="accent" v-model="dateTo" @input="dateChangeHandler(); picker2 = false"
            :min="dateFrom" :max="pickedMaxDate"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-spacer />
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12 sm12 md6 lg6 xl6>
        <v-menu v-model="picker3" :close-on-content-click="false" lazy transition="scale-transition"
          offset-y full-width min-width="290px">
          <v-text-field slot="activator" v-model="dateFrom" :label="$t('Pick Date')" prepend-icon="event"
            readonly>
          </v-text-field>
          <v-date-picker color="accent" v-model="dateFrom" @input="dateChangeHandler(); picker3 = false"
            :min="minDate"
            :max="maxToday"></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapGetters
} from 'vuex'
const momentTz = require('moment-timezone')

export default {
  props: {
    fullPicker: true,
    from: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    span: {
      type: [Number, String],
      default: 30
    },
    minDate: {
      type: String,
      default: ''
    },
    defaultDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dateFrom: '',
      dateTo: '',
      format: false,
      picker1: false,
      picker2: false,
      picker3: false,
      diffDaysMinus1: null
    }
  },
  computed: {
    ...mapGetters(['getActivePlantTimezone']),
    maxToday() {
      return momentTz.tz(this.defaultDate, this.getActivePlantTimezone).format('YYYY-MM-DD')
    },
    pickedMaxDate() {
      const tz = this.getActivePlantTimezone
      if (this.minDate && momentTz(this.dateFrom).tz(tz).isBefore(this.minDate)) {
        return this.maxToday
      }

      if (momentTz(this.dateFrom).tz(tz).add(this.diffDaysMinus1, 'day').diff(this.dateTo, 'day') <= this.span) {
        return momentTz(this.dateFrom).tz(tz).add(this.diffDaysMinus1, 'day').isBefore(this.maxToday) ? momentTz(this.dateFrom).tz(tz).add(this.diffDaysMinus1, 'day').format('YYYY-MM-DD') : this.maxToday
      }

      return this.maxToday
    }
  },
  mounted() {
    this.diffDaysMinus1 = this.span - 1
    if (this.from) {
      this.dateFrom = this.from
    } else {
      this.dateFrom = this.pickedMaxDate
    }

    if (this.to) {
      this.dateTo = this.to
    } else {
      this.dateTo = this.pickedMaxDate
    }
  },
  methods: {
    emitDate() {
      this.$emit('change:date', {
        from: this.dateFrom,
        to: this.dateTo
      })
    },
    dateChangeHandler() {
      const tz = this.getActivePlantTimezone
      if (momentTz(this.dateTo).tz(tz).isBefore(momentTz(this.dateFrom).tz(tz)) || !this.fullPicker) {
        this.dateTo = this.dateFrom
      }

      let diffDays = momentTz(this.dateTo).tz(tz).diff(this.dateFrom, 'days')
      if (this.fullPicker && diffDays >= this.span) {
        this.dateTo = momentTz(this.dateFrom).tz(tz).add(this.diffDaysMinus1, 'days').format('YYYY-MM-DD')
      }
      
      diffDays = momentTz(this.dateTo).tz(tz).diff(this.dateFrom, 'days')
      const diffMonth = momentTz(this.dateTo).tz(tz).diff(this.dateFrom, 'months')
      const start = momentTz(this.dateFrom).tz(tz)
        .startOf('month')
        .format('YYYY-MM-DD')
      const end = momentTz(this.dateTo).tz(tz)
        .startOf('month')
        .format('YYYY-MM-DD')

      if (momentTz(this.dateFrom).tz(tz).isSame(this.dateTo, 'month')) {
        if (diffDays <= momentTz(this.dateFrom).tz(tz).daysInMonth()) {
          this.emitDate()
        }
      } else if (
        !momentTz(this.dateFrom).tz(tz).isSame(this.dateTo, 'month') &&
        diffDays <= this.span
      ) {
        this.emitDate()
      } else if (
        start === this.dateFrom &&
        end === this.dateTo &&
        diffMonth >= 1
      ) {
        this.emitDate()
      } else {
        if (momentTz(this.dateFrom).tz(tz).isSame(this.dateTo, 'month')) {
          if (diffDays <= momentTz(this.dateFrom).tz(tz).daysInMonth()) {
            this.emitDate()
          }
        } else if (!momentTz(this.dateFrom).tz(tz).isSame(this.dateTo, 'month') && diffDays <= this.span) {
          this.emitDate()
        } else if (start === this.dateFrom && end === this.dateTo && diffMonth >= 1) {
          this.emitDate()
        } else {
          this.$emit('error:rangePick')
        }
      }
    }
  },
  watch: {
    from() {
      if (this.from) {
        this.dateFrom = this.from
      } else {
        this.dateFrom = this.pickedMaxDate
      }
    },
    to() {
      if (this.to) {
        this.dateTo = this.to
      } else {
        this.dateTo = this.pickedMaxDate
      }
    },
    defaultDate() {
      if (this.from) {
        this.dateFrom = this.from
      } else {
        this.dateFrom = this.pickedMaxDate
      }

      if (this.to) {
        this.dateTo = this.to
      } else {
        this.dateTo = this.pickedMaxDate
      }
    },
    minDate() {
      if (this.minDate) {
        this.dateFrom = this.pickedMaxDate
        this.dateTo = this.pickedMaxDate
      }
    },
    span() {
      this.diffDaysMinus1 = this.span - 1
      this.dateChangeHandler()
    }
  }
}
</script>
